import { setGetMediaAction } from '../action';
import { getMedia } from '../api/getMedia';

export const setGetMedia = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getMedia(params);
            dispatch(setGetMediaAction({
                data: data.data,
                current: 0,
                total: 0
            }))

            if (callback) {
                callback();
            }
            
          
        } catch(error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}